export default {
    error_to_send_file: 'Error al enviar el archivo, elimínelo y vuelva a intentarlo.',
    download_all_files: 'Descargar todos los archivos',
    sent_by: 'Enviado por {{name}}',
}
